/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const JobStatus = {
    Created: "created",
    Planning: "planning",
    Scheduled: "scheduled",
    Ready: "ready",
    Executing: "executing",
    Complete: "complete",
    Failed: "failed",
    Canceled: "canceled",
    Waiting: "waiting",
};
